import { Draggable, Droppable } from '@hello-pangea/dnd';
import { transportationKeys } from '../../../../../../../consts/conditions';

import ConditionBody from '../ConditionBody';
import ConditionalInput from '../ConditionalInput';
import classNames from 'classnames';
import ConditionBtnWithLine from '../ConditionBtnWithLine';
import AddFilterBtn from '../AddFilterBtn';
import FilterColumnCard from '../FilterColumnCard';
import ReplaceIcon from '../../../../../../../assets/icons/replace.svg?react';
import styled from 'styled-components';
import { Checkbox, Flex } from '@mantine/core';

export const DuplicateRows = ({
  isChildrenGroup,
  cuurentItem,
  filterTypes,
  onChangeOperator,
  onChangeThenInputType,
  onChangeThen,
  onSelectItem,
  onSelectCondition,
  parentFilterTypeId,
  addCondition,
  onAddListItem,
  onRemoveListItem,
  selectedItems,
  onDeleteSelectedItems,
  onChangeFunction,
  onChangeInputType,
  onChangeInput,
  onChangeColumn,
  columns
}) => {
  const removeNotAllowed = filterTypes?.[0]?.conditions?.length === 1;

  return (
    <>
      <div id="grid-table-duplicate-rows-root" className="condition-box">
        <div id="grid-table-duplicate-rows-list" className="filter-types">
          <Droppable droppableId={cuurentItem?.id} key={cuurentItem?.id}>
            {provided =>
              filterTypes
                .filter(item => item.conditions?.length > 0)
                .map((item, idx) => {
                  const filterTypeId = parentFilterTypeId || item.id;

                  return (
                    <div
                      key={item.id}
                      {...provided.droppableProps}
                      style={{ width: '100%' }}
                      ref={provided.innerRef}
                    >
                      <div
                        className={classNames('filter_card', {
                          ['isChildren']: isChildrenGroup,
                          ['noBorderTop']: true,
                          ['noBorderBottom']: true,
                          ['isFilter']: true
                        })}
                      >
                        <div
                          id={`grid-table-duplicate-rows-item-${idx}`}
                          className="filter_content"
                        >
                          <Flex justify="space-between" align="center">
                            <ConditionBtnWithLine
                              id={`grid-table-duplicate-rows-condition-${item.id}`}
                              withActions={!isChildrenGroup && idx === 0 && filterTypes?.length > 0}
                              onClickGroup={() => addCondition(item.id, 'group', filterTypeId)}
                              onClickDelete={() => onDeleteSelectedItems(filterTypeId)}
                              disableGroup={removeNotAllowed}
                              disableDelete={!selectedItems?.length > 0 || removeNotAllowed}
                              label={item.conditionLabel}
                              onSelectCondition={val =>
                                onSelectCondition(filterTypeId, val, item.id)
                              }
                            />

                            <Flex></Flex>
                          </Flex>

                          {item?.conditions?.map((value, idx) => {
                            if (value?.conditions?.length > 0)
                              return (
                                <Draggable key={value.id} draggableId={value.id} index={idx}>
                                  {(dragProvided, dragSnapshot) => {
                                    return (
                                      <div
                                        key={value.id}
                                        className="group-wrapper"
                                        ref={dragProvided.innerRef}
                                        {...dragProvided.draggableProps}
                                        style={{
                                          ...dragProvided.draggableProps.style,
                                          width: '100%',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '10px',
                                          opacity: dragSnapshot.isDragging ? 0.5 : 1
                                        }}
                                      >
                                        <div
                                          id={`grid-table-duplicate-rows-group-checkbox-${value.id}`}
                                          className="checkbox_line"
                                        >
                                          <Checkbox
                                            id={`grid-table-duplicate-rows-group-checkbox-input-${value.id}`}
                                            type="checkbox"
                                            className="checkbox"
                                            checked={selectedItems.includes(value.id)}
                                            onClick={() => onSelectItem(value.id)}
                                          />
                                        </div>

                                        <ConditionBody
                                          cuurentItem={value}
                                          filterTypes={[value]}
                                          selectedItems={selectedItems}
                                          onSelectItem={onSelectItem}
                                          addCondition={addCondition}
                                          isChildrenGroup={true}
                                          columns={columns}
                                          parentFilterTypeId={
                                            !isChildrenGroup ? filterTypeId : parentFilterTypeId
                                          }
                                          onChangeInput={onChangeInput}
                                          onChangeColumn={onChangeColumn}
                                          onChangeFunction={onChangeFunction}
                                          onChangeOperator={onChangeOperator}
                                          onChangeInputType={onChangeInputType}
                                          onSelectCondition={onSelectCondition}
                                        />

                                        <div
                                          id={`grid-table-duplicate-rows-group-replace-${value.id}`}
                                          className="replace-btn"
                                          {...dragProvided.dragHandleProps}
                                        >
                                          <ReplaceIcon />
                                        </div>
                                      </div>
                                    );
                                  }}
                                </Draggable>
                              );

                            return (
                              <Draggable key={value.id} draggableId={value.id} index={idx}>
                                {(dragProvided, dragSnapshot) => (
                                  <div
                                    id={`grid-table-duplicate-rows-row-${value.id}`}
                                    key={value.id}
                                    ref={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    style={{
                                      ...dragProvided.draggableProps.style,
                                      opacity: dragSnapshot.isDragging ? 0.5 : 1
                                    }}
                                  >
                                    <FilterColumnCard
                                      id={`grid-table-duplicate-rows-card-${value.id}`}
                                      key={value.id}
                                      operator={value.operator}
                                      column={value.column}
                                      func={value.function}
                                      value={value.value}
                                      inputType={value.inputType}
                                      columns={columns}
                                      errors={value.errors}
                                      dragHandleProps={{
                                        ...dragProvided.dragHandleProps
                                      }}
                                      hideFunction={true}
                                      isSelected={selectedItems.includes(value.id)}
                                      onSelect={() => onSelectItem(value.id)}
                                      onChangeFunction={val =>
                                        onChangeFunction(filterTypeId, value.id, val)
                                      }
                                      onChangeInputType={val =>
                                        onChangeInputType(filterTypeId, value.id, val)
                                      }
                                      onChangeColumn={val =>
                                        onChangeColumn(filterTypeId, value.id, val)
                                      }
                                      onChangeOperator={val =>
                                        onChangeOperator(filterTypeId, value.id, val)
                                      }
                                      onChangeInput={val =>
                                        onChangeInput(filterTypeId, value.id, val)
                                      }
                                      onAddListItem={val =>
                                        onAddListItem(filterTypeId, value.id, val)
                                      }
                                      onRemoveListItem={id =>
                                        onRemoveListItem(filterTypeId, value.id, id)
                                      }
                                    />
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}

                          {provided.placeholder}

                          <AddFilterBtn
                            id={`grid-table-duplicate-rows-add-${item.id}`}
                            onClick={type =>
                              addCondition(item.id, type, parentFilterTypeId || filterTypeId)
                            }
                          />
                        </div>

                        {!isChildrenGroup &&
                          (cuurentItem || item).label === transportationKeys.REPLACE && (
                            <div className="then">
                              <p style={{ marginTop: '17px' }}>Then</p>
                              <ConditionalInput
                                hideFunction={true}
                                columns={columns}
                                value={item?.then[item?.thenInputType]}
                                type={item?.thenInputType}
                                hideVariants={['ai_input']}
                                onChangeType={val =>
                                  onChangeThenInputType(filterTypeId, item.id, val)
                                }
                                onChangeValue={val => onChangeThen(filterTypeId, item.id, val)}
                              />
                            </div>
                          )}
                      </div>
                    </div>
                  );
                })
            }
          </Droppable>
        </div>
      </div>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  padding: 8px 0;
  border-top: 1px solid #cdd4df;

  .required {
    color: red !important;
  }

  .header {
    p {
      color: #2b313d;
      font-size: 10px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }

  .container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 8px;

    .input {
      display: flex;
      flex-direction: column;
      width: 50%;
      gap: 4px;

      input {
        border-radius: 6px;

        height: 24px;
        padding: 6px;
        color: #5c5d61;

        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      span {
        color: #5c5d61;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }

    .box {
      border: 1px solid #cdd4df;
      border-radius: 4px;
      padding: 8px;
      flex: 1;
      display: flex;
      flex-direction: column;

      .counter {
        width: 100%;
        border-bottom: 1px solid #cdd4df;
        padding-bottom: 8px;
      }

      .columns {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        padding: 8px 0;

        .input {
          width: calc(50% - 4px);
        }
      }
    }

    .result {
      width: 140px;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      div,
      .input {
        width: 100%;
      }
    }
  }
`;
